/**
 * Hook to read the AppContext value. Lives outside AppContext.tsx so the
 * provider file only exports components + the context itself, keeping
 * react-refresh from falling back to full reloads on every edit.
 */
import { useContext, type ContextType } from 'react';
import { AppContext } from '../context/AppContext';

export function useApp(): NonNullable<ContextType<typeof AppContext>> {
  const ctx = useContext(AppContext);
  if (!ctx) throw new Error('useApp must be used inside AppProvider');
  return ctx;
}
